import { ChevronRight } from '@unified-checkout/design-system/icons/index';
import { Link } from 'react-router-dom';

interface IAccordionLink {
  title: string;
  link: string;
}
export const AccordionLink = ({ title, link }: IAccordionLink) => {
  return (
    <Link to={link} className="flex items-center justify-between w-full pt-6">
      <p className="english-body-md-semibold">{title}</p>
      <div className="size-5">{ChevronRight}</div>
    </Link>
  );
};
